import React from 'react';

// components
import H from '@zola/zola-ui/src/typography/Headings';

// assets
import Brides from '../../../../../public/static-preauth/images/WeddingWebsiteLP/V3/Logos/brides.png';
import NewYorkTimes from '../../../../../public/static-preauth/images/WeddingWebsiteLP/V3/Logos/newyorktimes.png';
import People from '../../../../../public/static-preauth/images/WeddingWebsiteLP/V3/Logos/people.png';
import MarthaStewartWeddings from '../../../../../public/static-preauth/images/WeddingWebsiteLP/V3/Logos/marthastewartweddings.png';
import Today from '../../../../../public/static-preauth/images/WeddingWebsiteLP/V3/Logos/today.png';
import RealSimple from '../../../../../public/static-preauth/images/WeddingWebsiteLP/V3/Logos/realsimple.png';

// styles
import { Container, ImageContainer, StyledImage } from './ArticleLogos.styles';

const ArticleLogos: React.FC = () => {
  const images = [
    { alt: 'Brides', src: Brides },
    { alt: 'The New York Times', src: NewYorkTimes },
    { alt: 'People', src: People },
    { alt: 'Martha Stewart Weddings', src: MarthaStewartWeddings },
    { alt: 'Today', src: Today },
    { alt: 'Real Simple', src: RealSimple },
  ];

  return (
    <Container>
      <H.Title3 presentation="h5">Featured on</H.Title3>
      {images.map((image, i) => (
        <ImageContainer key={i}>
          <StyledImage alt={image.alt} src={image.src} />
        </ImageContainer>
      ))}
    </Container>
  );
};

export default ArticleLogos;
